export enum SubmissionSource {
  ProjectForm = 'Project Form',
  OrderProjectCertification = 'Order Project Certification',
  ProjectCloseout = 'Project Closeout',
  DraftingAccrediation = 'Drafting Accrediation',
  QualifyCredentials = 'Qualify Credentials',
  ProjectUpdate = 'Project Update',
  LicensingApplication = 'Licensing Application',
  ProjectRegistration = 'Project Registration'
}

export enum RequestStatus {
  Pending = 'Pending',
  Abandoned = 'Abandoned',
  Completed = 'Completed',
  InProgress = 'In Progress',
  ManuallyEntered = 'Manually Entered'
}

export enum TestNames {
  Standards = '2019 AWS Written Test',
  Policies = '2019 Policies Test',
  Drafting = '2019 Individual Drafting Accreditation (IDA) - AWS Standards Test'
}

export enum TestTypes {
  Standards = 'Standards',
  Policies = 'Policies',
  Drafting = 'Drafting'
}